/**
 * @file FormGroupTopInfoSlot.tsx
 *
 * @fileoverview Shows information for a given form group.
 */
import { useIntl } from 'react-intl';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { FlexItem } from '~/vcl/atoms/06-layout/03-flex/02-flex-item';
import { InfoIcon } from '~/vcl/icons/Info';
import { Popover } from '~/vcl/atoms/16-popover';
import styles from './topInfoSlot.module.scss';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';

interface FormGroupTopInfoSlotProps {
  /**
   * The form group.
   */
  group: Slottable<any>;
  /**
   * The bundle of the entity to be displayed (job_per_template, job_per_link).
   */
  bundle?: Slottable<string>;
  /**
   * The name of the entity to be displayed (node, user, profile).
   */
  name: Slottable<string>;
}

export default function FormGroupTopInfoSlot({
  group,
  bundle,
  name,
}: FormGroupTopInfoSlotProps) {
  const intl = useIntl();
  if (group.top_info_popover) {
    return (
      <FlexItems justifyContent="flex-end">
        <FlexItem>
          <Popover trigger={<InfoIcon title="Info" />}>
            <div className={styles.topInfoContent}>
              <div className={styles.topInfoText}>
                <WYSIWYGText
                  format="filtered_html"
                  content={
                    group.top_info_popover &&
                    !!intl.messages &&
                    intl.messages?.[`config_form_${group.key}_top_info_popover`]
                      ? (intl.messages[
                          `config_form_${group.key}_top_info_popover`
                        ] as any)
                      : group.top_info_popover
                  }
                />
              </div>
            </div>
          </Popover>
        </FlexItem>
      </FlexItems>
    );
  }
  return null;
}

export { FormGroupTopInfoSlot };
